var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheNavigation',{attrs:{"toggled-mobile-menu":_vm.toggledMobileMenu},on:{"toggle-mobile-menu":_vm.toggleMobileMenu}}),_c('TheMain',[_vm._t("default")],2),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }